import type { ComponentProps } from 'react';

export type PaginationItemProps = ComponentProps<'li'>;

const PaginationItem = ({ ...props }: PaginationItemProps) => {
  return <li data-slot="pagination-item" {...props} />;
};

export default PaginationItem;
